(function () {
  function mobileFlag() {
    return window.innerWidth < 900 ? 1 : 0;
  }

  whenGonaJQuery(function () {
    var is_marketing_img = 0;
    var marketing_index = setInterval(function () {
      try {
        var iframeEl = document.getElementById('automizely_marketing_popup_bars');
        if (!iframeEl) return;
        var iframeDoc = iframeEl.contentDocument;
        if (iframeDoc.querySelector('#modal-content1')) {
          iframeDoc.querySelector(
            '#modal-content1  div.mars41.mars45 > span'
          ).style =
            'text-align: center;color: #fff;display: block;margin-bottom: 0rem!important;white-space: pre-line;font-weight: 800!important;';

          var img_html =
            '<img loading="lazy" src="https://cdn.shopify.com/s/files/1/0549/2051/1688/files/1_dfb741b9-0b05-4200-b8a2-8fd6302d397f.jpg?v=1767081735" style="width: 100%;margin-bottom: 10px;margin-top: -10px;">';
          if (!is_marketing_img) {
            iframeDoc.querySelector('#modal-content1  form').insertAdjacentHTML('beforebegin', img_html);
            is_marketing_img = 1;
          }

          var m_bottom = '15%';
          if (window.innerWidth < 375) {
            m_bottom = '5%';
          } else if (window.innerWidth >= 375 && window.innerWidth < 414) {
            m_bottom = '10%';
          }
          var isMobile = typeof window.isMobile !== 'undefined' ? window.isMobile : mobileFlag();
          if (isMobile) {
            iframeDoc.querySelector('.MuiPaper-root').style.marginBottom = m_bottom;
          }
          iframeDoc.querySelector('.customPreviewModal-0-0-3 .MuiPaper-root').style.maxHeight = isMobile
            ? '560px'
            : '960px';
          $('.MuiDialog-root').css('display', 'block');
          iframeDoc.querySelector("#modal-title1 button[aria-label='close']").style.color = '#fff';
          clearInterval(marketing_index);
        }
      } catch (e) {}
    }, 1000);

    var success_marketing_index = setInterval(function () {
      try {
        var iframeEl = document.getElementById('automizely_marketing_popup_bars');
        if (!iframeEl) return;
        var iframeDoc1 = iframeEl.contentDocument;
        if (iframeDoc1.querySelector('#modal-content2')) {
          iframeDoc1.querySelector("button[aria-label='close']").style.color = '#fff';
          clearInterval(success_marketing_index);
        }
      } catch (e) {}
    }, 1000);

    var coupon_marketing_index = setInterval(function () {
      try {
        var iframeEl = document.getElementById('automizely_marketing_popup_bars');
        if (!iframeEl) return;
        var iframeDoc3 = iframeEl.contentDocument;
        if (iframeDoc3.querySelector('.jss1')) {
          iframeDoc3.querySelector("button[aria-label='close']").style.color = '#fff';
          iframeDoc3.querySelector('.MuiButtonBase-root svg').style.fontSize = '2rem';
          clearInterval(coupon_marketing_index);
        }
      } catch (e) {}
    }, 1000);
  });
})();
